import { Arrays } from "../../../library-js/tools/Arrays";
import { isClassOf } from "../../../library-js/tools/TypeUtilities";
import { NodeGraph } from "./NodeGraph";
import { NodeGraphEdge } from "./NodeGraphEdge";
import { NodeGraphNode } from "./NodeGraphNode";
import { NodeGraphReference } from "./NodeGraphReference";

export class NodeGraphSelection
{
  _nodeGraph:NodeGraph;
  private _references:string[] = [];

  get all()
  {
    return this._references;
  }

  _set:Set<string> = new Set<string>();

  constructor( ng:NodeGraph )
  {
    this._nodeGraph = ng;
  }

  get isEmpty()
  {
    return this._references.length === 0;
  }

  forAllNodes( action:( n:NodeGraphNode ) => void )
  {
    this._references.forEach(
      ( id )=>
      {
        let reference = this._nodeGraph.get( id );

        if ( ! isClassOf( reference, NodeGraphNode ) )
        {
          return;
        }

        action( reference as NodeGraphNode );
      }
    )
  }

  clone() 
  {
    let selection = new NodeGraphSelection( this._nodeGraph );    
    selection._references = [].concat( this._references );

    return selection;

  }

  setByID( references:string[], replace:boolean = true )
  {
    if ( replace )
    {
      this._references = [].concat( references );
    } 
    else
    {
      references.forEach(
        r =>
        {
          if ( ! this.hasID( r ) )
          {
            this._references.push( r );
          }
          else
          {
            Arrays.remove( this._references, r );
          }

        }
      )
    } 
    
    this._set = new Set<string>( this._references );
  }

  set( references:NodeGraphReference[], replace:boolean = true )
  {    
    if ( replace )
    {
      this._references = references.map( r => r._id );    
    } 
    else
    {
      references.forEach(
        r =>
        {
          if ( ! this.has( r ) )
          {
            this._references.push( r._id );
          }
          else
          {
            Arrays.remove( this._references, r._id );
          }

        }
      )
    } 
    
    this._set = new Set<string>( this._references );
  }

  has( reference:NodeGraphReference )
  {
    return this._set.has( reference._id );
  }

  hasID( id:string )
  {
    return this._set.has( id );
  }


  apply()
  {
    let selectedSet = new Set<string>( this._references );

    this._nodeGraph._references.forEach( 
      ( r )=>
      {
        r.setSelectionState( selectedSet.has( r._id ) );
      }
    );

    this._nodeGraph._ui.updateEdges();
  } 

}